<template>
<div class="chapter">
<div class="inner_page">
<p class="chapter-h"><span><i>Note on Intervolumens</i></span></p>
<p class="normal">The three books of the trilogy make up, in the original format, <i>one</i> long book, composed of scrolls – here represented as Volumes. The <i>Intervolumens</i> are interpolated adventures and developments from other richer sources – since, in the scrolls of Lionwolf, many of these events are detailed sketchily, and in a sort of shorthand.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frantmatter03.vue?34daa09e